<template>
  <div class="text-center">
    <div class="row text-center">
      <span class="text-end fs-3 pointer pe-0" @click.prevent="$emit('close')"><i class="fa-solid fa-xmark"></i></span>
      <img src="@/assets/img/language-chooser.png" alt="" class="m-auto" style="height: 140px !important; width: 270px !important;" />
      <div>
        <div class="col-12">
          <h3 class="my-4">{{ $t('choose-language') }}</h3>
        </div>
      </div>
      <div class="">
        <div class="col-10 offset-1">
          <v-select
          id="current_language"
          v-model="currentLanguage"
          data-test="current_language"
          :options="supportedLanguages"
          label="name"
          :placeholder="this.$t('LanguageChooser.select-your-language')"
          :filterable="false"
          ></v-select>
        </div>
      </div>
      <div class="mt-4">
        <div v-if="showLanguageChangeStatus" class="col-12 text-success pb-3">
          <h5 class="text-success">
            <i class="fa fa-check-circle fa-xl"></i>
            {{ $t('language-change-status') }}
          </h5>
        </div>
        <button id="change-language" data-test="change-language" class="btn btn-primary btn-block btn-md" @click="changeLanguage">{{ $t('save-and-close') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'LanguageChooser',
  components: {
    vSelect,
  },
  data() {
    return {
      currentLanguage: '',
      showLanguageChangeStatus: false,
    };
  },
  computed: {
    supportedLanguages() {
      return this.$i18n.i18next.options.supportedLanguages;
    },
  },
  methods: {
    changeLanguage() {
      this.$store.dispatch('lang/setLocale', this.currentLanguage.code);
      this.showLanguageChangeStatus = true;
      setTimeout(() => {
        this.showLanguageChangeStatus = false;
        this.$emit('close');
      }, 1000);
    },
  },
};
</script>
<style scoped>
.vs__dropdown-toggle {
  padding: 10px !important;
  border: solid 1px black;
}
.vs__clear {
  display: none;
}
</style>
